module.exports = __webpack_public_path__ + "img/mozilla_firefox.cfc25568.svg";